import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mock';
import { useLanguage } from '../i18n/LanguageContext';

export const Testimonials = () => {
  const { t } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 7000);
    return () => clearInterval(timer);
  }, []);

  const active = testimonials[activeIndex];

  return (
    <section
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-neutral-950 text-neutral-100 relative overflow-hidden"
    >
      <div className="absolute top-0 right-1/3 w-[500px] h-[500px] rounded-full bg-[#c8b6d9] opacity-[0.03] blur-[140px] pointer-events-none"></div>

      <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-16 relative">
        <div className="mb-16">
          <div className="flex items-center gap-4 mb-8">
            <span className="divider-line"></span>
            <span className="eyebrow text-lilac">{t.testimonials.eyebrow}</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-neutral-100 tracking-tight mb-5">
            {t.testimonials.title}
          </h2>
          <p className="eyebrow text-sage">{t.testimonials.subtitle}</p>
        </div>

        <div className="relative">
          <span
            aria-hidden="true"
            className="absolute -top-20 -left-4 md:-left-10 font-display text-[12rem] md:text-[16rem] leading-none text-lilac opacity-[0.12] select-none"
          >
            &ldquo;
          </span>

          <div
            key={active.id}
            data-testid={`testimonial-${active.id}`}
            className="relative"
            style={{ animation: 'fadeIn 0.8s ease-out' }}
          >
            <div className="flex items-center gap-1 mb-8">
              {Array.from({ length: active.rating }).map((_, i) => (
                <Star key={i} size={16} fill="#c8b6d9" strokeWidth={0} className="text-lilac" />
              ))}
            </div>
            <p className="font-display italic text-2xl md:text-3xl lg:text-4xl leading-[1.35] text-neutral-100 mb-12 font-light">
              {active.text}
            </p>
            <div className="flex items-center gap-5">
              <span className="h-px w-10 bg-lilac"></span>
              <p className="eyebrow text-neutral-300">— {active.name}</p>
            </div>
          </div>
        </div>

        {/* Indicators */}
        <div className="flex items-center gap-3 mt-20 flex-wrap">
          {testimonials.map((item, i) => (
            <button
              key={item.id}
              onClick={() => setActiveIndex(i)}
              data-testid={`testimonial-dot-${i}`}
              aria-label={`Review ${i + 1}`}
              className={`h-px transition-all duration-500 ${
                i === activeIndex ? 'w-16 bg-lilac' : 'w-8 bg-white/20 hover:bg-white/40'
              }`}
            ></button>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
};
